import { useState, useRef } from "react";
import HomeVideoView from "./HomeVideoView";
import "react-multi-carousel/lib/styles.css";
import { useSwipeable } from 'react-swipeable';
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";

// Keep 1 previous + current + 2 next videos mounted simultaneously.
// Each has its own live HLS instance buffering in the background, so when
// the user scrolls, the incoming video just slides into position — no mount,
// no HLS init, no segment download delay. Same architecture as Instagram/TikTok.
const WINDOW_OFFSETS = [-1, 0, 1, 2];

const VideoCarousel = ({
    videos,
    setPreButton,
    setNextButton,
    spilThashTags,
    summary,
    fetchData,
    id,
    handleReshared,
    setPageCount,
    itsNotHome,
    yourFeeds,
    handleReadUserStatus,
    newUser,
    resharedPostId,
    rehsaredMesaage,
    setResharedPostId,
    handleFollowFun,
    totalVideos,
    currentIndex,
    direction,
    handleNext,
    handlePrev,
    isMobile,
    isFollow,
    handleRefresh,
    playbackSpeed,
    setPlaybackSpeed,
    loading,
    videoCommentCount,
    videoLikeCount,
    userLogin,
    handleInteraction,
    enableAutoplay,
    muteVideosByDefault,
    exitReasonHint,
    onVideoReady,
}) => {
    const [isSliderActive, setIsSliderActive] = useState(false);
    const reportedPostIdsRef = useRef(new Set());

    const params = useParams();
    const { id: videoId } = params;

    const handleSliderStart = () => setIsSliderActive(true);
    const handleSliderEnd = () => setIsSliderActive(false);

    const handleMarkAsReported = (postId) => {
        reportedPostIdsRef.current.add(postId);
    };

    const handleRemoveReported = (postId) => {
        reportedPostIdsRef.current.delete(postId);
    };
    const swipeHandlers = useSwipeable({
        onSwipedUp: isMobile ? handleNext : undefined,
        onSwipedDown: isMobile ? handlePrev : undefined,
        preventDefaultTouchmoveEvent: false,
        trackMouse: false,
    });

    return (
        <div className="relative flex items-center justify-center w-full h-full overflow-hidden">
            <div className={`w-full h-full flex ${isMobile ? 'flex-col' : 'flex-row'} relative`}>
                {WINDOW_OFFSETS.map(offset => {
                    const idx = currentIndex + offset;
                    if (idx < 0 || idx >= videos.length) return null;
                    const v = videos[idx];
                    const isActive = offset === 0;

                    return (
                        // key=v.id keeps the same component instance alive as it moves
                        // through the window — framer-motion animates its position change.
                        <motion.div
                            key={v.id}
                            initial={{ y: `${offset * 100}%` }}
                            animate={{ y: `${offset * 100}%` }}
                            transition={{
                                y: { type: "spring", stiffness: 360, damping: 34, mass: 0.7 },
                            }}
                            className="absolute inset-0 w-full h-full flex items-center justify-center"
                        >
                            <div
                                {...(isActive ? swipeHandlers : {})}
                                className="w-full h-full border-none"
                            >
                                <HomeVideoView
                                    id={v.id}
                                    src={v.video_url}
                                    isActive={isActive}
                                    summary={summary}
                                    comments={v.comments}
                                    spilThashTags={spilThashTags}
                                    created_by={v.created_by}
                                    created_at={v.created_at}
                                    dec={v.post_description}
                                    thumbnail_url={v.thumbnail_url}
                                    like_count={v.likes_count}
                                    comments_count={v.comment_thread_count}
                                    handleReshared={handleReshared}
                                    userreshared={v.userreshared}
                                    handleReadUserStatus={handleReadUserStatus}
                                    newUser={newUser}
                                    resharedPostId={resharedPostId}
                                    rehsaredMesaage={rehsaredMesaage}
                                    setResharedPostId={setResharedPostId}
                                    userfollowing={v.userfollowing}
                                    handleFollowFun={handleFollowFun}
                                    user_liked={v.userliked}
                                    user_saved={v.usersaved}
                                    handleSliderStart={handleSliderStart}
                                    handleSliderEnd={handleSliderEnd}
                                    isFollow={isFollow}
                                    handleRefresh={handleRefresh}
                                    comments_enabled={v.comments_enabled}
                                    download_enabled={v.download_enabled}
                                    playbackSpeed={playbackSpeed}
                                    setPlaybackSpeed={setPlaybackSpeed}
                                    videoId={videoId}
                                    itsNotHome={itsNotHome}
                                    yourFeeds={yourFeeds}
                                    videos={videos}
                                    loading={loading}
                                    videoCommentCount={videoCommentCount}
                                    videoLikeCount={videoLikeCount}
                                    userLogin={userLogin}
                                    handleInteraction={handleInteraction}
                                    enableAutoplay={enableAutoplay}
                                    muteVideosByDefault={muteVideosByDefault}
                                    handleNext={handleNext}
                                    exitReasonHint={exitReasonHint}
                                    onVideoReady={isActive ? onVideoReady : undefined}
                                    reported={v.post_reported_show_popup}
                                    reportedPostIdsRef={reportedPostIdsRef}
                                    onMarkAsReported={handleMarkAsReported}
                                    onRemoveReported={handleRemoveReported}
                                />
                            </div>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    );
};

export default VideoCarousel;